import Cookies from 'js-cookie'
import Mgr from '../services/SecurityService'

const TokenKey = 'Admin-Token'
var user = new Mgr()

export function getToken() {
  return user.getAcessToken()
}

export function setToken(token) {
  Cookies.set('Base-Api', process.env.VUE_APP_BASE_API)
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
